import React from 'react'
import { IconInfoCircle } from '@tabler/icons-react'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

import './InfoTooltip.scss'

// Small "(i)" affordance: an info glyph that reveals explanatory copy on
// hover/focus. Reuses the shared InteractiveTooltip so placement and
// styling match the rest of the app. Renders nothing without `content`,
// so callers can pass an optional description straight through.
//
// @param {React.ReactNode} props.content - the explanatory text/node
// @param {string} [props.label] - accessible name for the icon
// @param {number} [props.size] - icon size in px
export const InfoTooltip = ({ content, label = 'More information', size = 15, className }) => {
  if (!content) {
    return null
  }
  return (
    <InteractiveTooltip content={content}>
      <IconInfoCircle
        className={className ? `info-tooltip-icon ${className}` : 'info-tooltip-icon'}
        size={size}
        role="img"
        aria-label={label}
        tabIndex={0}
      />
    </InteractiveTooltip>
  )
}
